import React, { useEffect, useState } from "react";
import { TopBar } from "@/components/TopBar";
import { useI18n } from "@/i18n";
import { useRouter } from "@/router/Router";
import { useCart } from "@/state/CartContext";
import { fetchSubscription } from "@/lib/api";

/** Opened from the bot reminder: puts the subscription into the cart and goes to checkout. */
export function SubscriptionReorderPage({ id }: { id: string }) {
  const { t } = useI18n();
  const { navigate } = useRouter();
  const { addItem } = useCart();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetchSubscription(id)
      .then((s) => {
        addItem(s.productId, s.variantId, s.quantity);
        navigate({ name: "checkout" });
      })
      .catch(() => setFailed(true));
  }, [id]);

  return (
    <>
      <TopBar title={t("subscription.listTitle")} onBack={() => navigate({ name: "home" })} />
      <main className="page page--no-nav">{failed ? t("common.error") : t("common.loading")}</main>
    </>
  );
}
